import { Company, Loads, Notifiactions, SavedProject, Trucks } from './../types';
import { ProRole } from './payment';

export interface User {
  email: string;
  role: string;
  providers: string[];
  verified: boolean;
  firstName: string;
  lastName: string;
  companyName: string;
  vatId: string;
  job: string;
  loadingSpaceTypes: number[];
  trucks: Trucks;
  loads: Loads;
  savedProjects: SavedProject[];
  country: string;
  token?: string;
  company?: Company;
  isPremium?: boolean;
  premiumRole?: ProRole;
  acceptedConsents?: string[];
  notifications: Notifiactions[];
  hasIntegration: boolean | 'waiting';
  oldDataTransferred?: boolean;
  registrationDate?: string;
}
export class User implements User {}
